import { Observable } from 'rxjs/Observable';
import { throwError as observableThrowError } from 'rxjs'
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  /**
   * @desc Intercept request to handle response in case of error
   * @param {HttpRequest} request - Request to be handled
   * @param {HttpHandler} next - Http HttpHandler
   * @return {Observable}
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next
      .handle(request).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpErrorResponse) {
            throw observableThrowError(event);
          }
        }, (error: any) => {
            return observableThrowError(error || 'Server error');
          })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/error.interceptor.ts